import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineProps } from "vue/dist/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RouterLinkCustom',
  props: {
    text: {},
    route: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "text-custom-middleGray text-left text-lg md:text-xl",
    to: props.route
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(props.text), 1)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})